import { useState } from 'react';
import PropTypes from 'prop-types';
import { appendQueryString, getQueryObject, ROUTES } from 'Utils';
import * as analytics from 'Utils/analytics';
import { withLogin } from 'Components/hocs';
const { EVENTS } = analytics;

const ResendVerification = (props) => {
  const [emailFailed, setEmailFailed] = useState(false);

  const backToLogin = () => {
    analytics.event({ action: EVENTS.resendBack, label: 'resendBack' });
    const route =
      getQueryObject(props)?.redirectTo ??
      appendQueryString(ROUTES.PAGE_HOME.url);
    window.location.href = route;
  };

  const resendEmail = async () => {
    analytics.event({
      action: EVENTS.resendVerification,
      label: 'resendVerification',
    });
    setEmailFailed(false);
    const sent = await props.uim.resendVerificationEmail();
    if (!sent) return setEmailFailed(true);
    props.transitionTo(ROUTES.PAGE_VERIFICATION_SENT.url);
  };

  return (
    <div>
      <h1 className="page-heading">{props.strings.verificationRequired}</h1>
      <p className="break-word">
        {props.strings.verificationMessage.formatUimTranslation(props.email)}
      </p>
      <button onClick={backToLogin}>
        {props.strings.verificationBackToLogin}
      </button>
      <div className="sublink" onClick={resendEmail}>
        {props.strings.didNotReceive}
      </div>
      {emailFailed && (
        <div className="error-text">
          {props.strings.verificationEmailFailed}
        </div>
      )}
    </div>
  );
};

ResendVerification.propTypes = {
  email: PropTypes.string.isRequired,
  strings: PropTypes.object.isRequired,
  uim: PropTypes.object.isRequired,
};

export default withLogin(ResendVerification);
